export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Vain käteinen ravintolassa. Korttimaksua ei hyväksytä.',
  },
};
